import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enHomepage from "./en/homepage.json";
import hiHomepage from "./hi/homepage.json";
import enHeader from "./en/header.json";
import hiHeader from "./hi/header.json";
import enVision from "./en/vision.json";
import hiVision from "./hi/vision.json";
import enEcosystem from "./en/ecosystem.json";
import hiEcosystem from "./hi/ecosystem.json";
import enContactUs from "./en/contact.json";
import hiContactUs from "./hi/contact.json";
import enAboutMst from "./en/about.json";
import hiAboutMst from "./hi/about.json";
import enValidationProcess from "./en/blockvalidation.json";
import hiValidationProcess from "./hi/blockvalidation.json";
import enDaoAndMstChain from "./en/daoandmstchain.json";
import hiDaoAndMstChain from "./hi/daoandmstchain.json";
import enFractionalNode from "./en/fractionalnode.json";
import hiFractionalNode from "./hi/fractionalnode.json";
import enEvmBlockChain from "./en/evmblockchain.json";
import hiEvmBlockChain from "./hi/evmblockchain.json";
import enAmbassador from "./en/ambassador.json";
import hiAmbassador from "./hi/ambassador.json";
import enTransparency from "./en/transparency.json";
import hiTransparency from "./hi/transparency.json";
import enSolutionsSlug from "./en/solutions.json";
import hiSolutionsSlug from "./hi/solutions.json";
import enBuildOnMst from "./en/buildonmst.json";
import hiBuildOnMst from "./hi/buildonmst.json";
import enPrivacyPolicy from "./en/privacy.json";
import hiPrivacyPolicy from "./hi/privacy.json";
import enTermsAndCondition from "./en/terms.json";
import hiTermsAndCondition from "./hi/terms.json";
import enCancellation from "./en/cancellation.json";
import hiCancellation from "./hi/cancellation.json";
import enKycPolicy from "./en/kycpolicy.json";
import hiKycPolicy from "./hi/kycpolicy.json";
import enAmlPolicy from "./en/amlpolicy.json";
import hiAmlPolicy from "./hi/amlpolicy.json";
import enTeamAndPartner from "./en/teampartner.json";
import hiTeamAndPartner from "./hi/teampartner.json";
import enCommunity from "./en/community.json";
import hiCommunity from "./hi/community.json";
import enMstResearchProgram from "./en/mstresearch.json";
import hiMstResearchProgram from "./hi/mstresearch.json";
import enFooter from "./en/footer.json";
import hiFooter from "./hi/footer.json";
import enNotFound from "./en/notfound.json";
import hiNotFound from "./hi/notfound.json";
import vtHomepage from "./vt/homepage.json";
import vtAboutMst from "./vt/about.json";
import vtAmbassador from "./vt/ambassador.json";
import vtAmlPolicy from "./vt/amlpolicy.json";
import vtValidationProcess from "./vt/blockvalidation.json";
import vtBuildOnMst from "./vt/buildonmst.json";
import vtCancellation from "./vt/cancellation.json";
import vtCommunity from "./vt/community.json";
import vtContactUs from "./vt/contact.json";
import vtDaoAndMstChain from "./vt/daoandmstchain.json";
import vtEcosystem from "./vt/ecosystem.json";
import vtEvmBlockChain from "./vt/evmblockchain.json";
import vtFooter from "./vt/footer.json";
import vtFractionalNode from "./vt/fractionalnode.json";
import vtHeader from "./vt/header.json";
import vtKycPolicy from "./vt/kycpolicy.json";
import vtMstResearchProgram from "./vt/mstresearch.json";
import vtNotFound from "./vt/notfound.json";
import vtPrivacyPolicy from "./vt/privacy.json";
import vtSolutionsSlug from "./vt/solutions.json";
import vtTeamAndPartner from "./vt/teampartner.json";
import vtTermsAndCondition from "./vt/terms.json";
import vtTransparency from "./vt/transparency.json";
import vtVision from "./vt/vision.json";
import thHomepage from "./th/homepage.json";
import thAboutMst from "./th/about.json";
import thAmbassador from "./th/ambassador.json";
import thAmlPolicy from "./th/amlpolicy.json";
import thValidationProcess from "./th/blockvalidation.json";
import thBuildOnMst from "./th/buildonmst.json";
import thCancellation from "./th/cancellation.json";
import thCommunity from "./th/community.json";
import thContactUs from "./th/contact.json";
import thDaoAndMstChain from "./th/daoandmstchain.json";
import thEcosystem from "./th/ecosystem.json";
import thEvmBlockChain from "./th/evmblockchain.json";
import thFooter from "./th/footer.json";
import thFractionalNode from "./th/fractionalnode.json";
import thHeader from "./th/header.json";
import thKycPolicy from "./th/kycpolicy.json";
import thMstResearchProgram from "./th/mstresearch.json";
import thNotFound from "./th/notfound.json";
import thPrivacyPolicy from "./th/privacy.json";
import thSolutionsSlug from "./th/solutions.json";
import thTeamAndPartner from "./th/teampartner.json";
import thTermsAndCondition from "./th/terms.json";
import thTransparency from "./th/transparency.json";
import thVision from "./th/vision.json";
import filHomepage from "./fil/homepage.json";
import filAboutMst from "./fil/about.json";
import filAmbassador from "./fil/ambassador.json";
import filAmlPolicy from "./fil/amlpolicy.json";
import filValidationProcess from "./fil/blockvalidation.json";
import filBuildOnMst from "./fil/buildonmst.json";
import filCancellation from "./fil/cancellation.json";
import filCommunity from "./fil/community.json";
import filContactUs from "./fil/contact.json";
import filDaoAndMstChain from "./fil/daoandmstchain.json";
import filEcosystem from "./fil/ecosystem.json";
import filEvmBlockChain from "./fil/evmblockchain.json";
import filFooter from "./fil/footer.json";
import filFractionalNode from "./fil/fractionalnode.json";
import filHeader from "./fil/header.json";
import filKycPolicy from "./fil/kycpolicy.json";
import filMstResearchProgram from "./fil/mstresearch.json";
import filNotFound from "./fil/notfound.json";
import filPrivacyPolicy from "./fil/privacy.json";
import filSolutionsSlug from "./fil/solutions.json";
import filTeamAndPartner from "./fil/teampartner.json";
import filTermsAndCondition from "./fil/terms.json";
import filTransparency from "./fil/transparency.json";
import filVision from "./fil/vision.json";
import kmHomepage from "./km/homepage.json";
import kmAboutMst from "./km/about.json";
import kmAmbassador from "./km/ambassador.json";
import kmAmlPolicy from "./km/amlpolicy.json";
import kmValidationProcess from "./km/blockvalidation.json";
import kmBuildOnMst from "./km/buildonmst.json";
import kmCancellation from "./km/cancellation.json";
import kmCommunity from "./km/community.json";
import kmContactUs from "./km/contact.json";
import kmDaoAndMstChain from "./km/daoandmstchain.json";
import kmEcosystem from "./km/ecosystem.json";
import kmEvmBlockChain from "./km/evmblockchain.json";
import kmFooter from "./km/footer.json";
import kmFractionalNode from "./km/fractionalnode.json";
import kmHeader from "./km/header.json";
import kmKycPolicy from "./km/kycpolicy.json";
import kmMstResearchProgram from "./km/mstresearch.json";
import kmNotFound from "./km/notfound.json";
import kmPrivacyPolicy from "./km/privacy.json";
import kmSolutionsSlug from "./km/solutions.json";
import kmTeamAndPartner from "./km/teampartner.json";
import kmTermsAndCondition from "./km/terms.json";
import kmTransparency from "./km/transparency.json";
import kmVision from "./km/vision.json";
import dvHomepage from "./dv/homepage.json";
import dvAboutMst from "./dv/about.json";
import dvAmbassador from "./dv/ambassador.json";
import dvAmlPolicy from "./dv/amlpolicy.json";
import dvValidationProcess from "./dv/blockvalidation.json";
import dvBuildOnMst from "./dv/buildonmst.json";
import dvCancellation from "./dv/cancellation.json";
import dvCommunity from "./dv/community.json";
import dvContactUs from "./dv/contact.json";
import dvDaoAndMstChain from "./dv/daoandmstchain.json";
import dvEcosystem from "./dv/ecosystem.json";
import dvEvmBlockChain from "./dv/evmblockchain.json";
import dvFooter from "./dv/footer.json";
import dvFractionalNode from "./dv/fractionalnode.json";
import dvHeader from "./dv/header.json";
import dvKycPolicy from "./dv/kycpolicy.json";
import dvMstResearchProgram from "./dv/mstresearch.json";
import dvNotFound from "./dv/notfound.json";
import dvPrivacyPolicy from "./dv/privacy.json";
import dvSolutionsSlug from "./dv/solutions.json";
import dvTeamAndPartner from "./dv/teampartner.json";
import dvTermsAndCondition from "./dv/terms.json";
import dvTransparency from "./dv/transparency.json";
import dvVision from "./dv/vision.json";
import zhHomepage from "./zh/homepage.json";
import zhAboutMst from "./zh/about.json";
import zhAmbassador from "./zh/ambassador.json";
import zhAmlPolicy from "./zh/amlpolicy.json";
import zhValidationProcess from "./zh/blockvalidation.json";
import zhBuildOnMst from "./zh/buildonmst.json";
import zhCancellation from "./zh/cancellation.json";
import zhCommunity from "./zh/community.json";
import zhContactUs from "./zh/contact.json";
import zhDaoAndMstChain from "./zh/daoandmstchain.json";
import zhEcosystem from "./zh/ecosystem.json";
import zhEvmBlockChain from "./zh/evmblockchain.json";
import zhFooter from "./zh/footer.json";
import zhFractionalNode from "./zh/fractionalnode.json";
import zhHeader from "./zh/header.json";
import zhKycPolicy from "./zh/kycpolicy.json";
import zhMstResearchProgram from "./zh/mstresearch.json";
import zhNotFound from "./zh/notfound.json";
import zhPrivacyPolicy from "./zh/privacy.json";
import zhSolutionsSlug from "./zh/solutions.json";
import zhTeamAndPartner from "./zh/teampartner.json";
import zhTermsAndCondition from "./zh/terms.json";
import zhTransparency from "./zh/transparency.json";
import zhVision from "./zh/vision.json";
import ruHomepage from "./ru/homepage.json";
import ruAboutMst from "./ru/about.json";
import ruAmbassador from "./ru/ambassador.json";
import ruAmlPolicy from "./ru/amlpolicy.json";
import ruValidationProcess from "./ru/blockvalidation.json";
import ruBuildOnMst from "./ru/buildonmst.json";
import ruCancellation from "./ru/cancellation.json";
import ruCommunity from "./ru/community.json";
import ruContactUs from "./ru/contact.json";
import ruDaoAndMstChain from "./ru/daoandmstchain.json";
import ruEcosystem from "./ru/ecosystem.json";
import ruEvmBlockChain from "./ru/evmblockchain.json";
import ruFooter from "./ru/footer.json";
import ruFractionalNode from "./ru/fractionalnode.json";
import ruHeader from "./ru/header.json";
import ruKycPolicy from "./ru/kycpolicy.json";
import ruMstResearchProgram from "./ru/mstresearch.json";
import ruNotFound from "./ru/notfound.json";
import ruPrivacyPolicy from "./ru/privacy.json";
import ruSolutionsSlug from "./ru/solutions.json";
import ruTeamAndPartner from "./ru/teampartner.json";
import ruTermsAndCondition from "./ru/terms.json";
import ruTransparency from "./ru/transparency.json";
import ruVision from "./ru/vision.json";
import trHomepage from "./tr/homepage.json";
import trAboutMst from "./tr/about.json";
import trAmbassador from "./tr/ambassador.json";
import trAmlPolicy from "./tr/amlpolicy.json";
import trValidationProcess from "./tr/blockvalidation.json";
import trBuildOnMst from "./tr/buildonmst.json";
import trCancellation from "./tr/cancellation.json";
import trCommunity from "./tr/community.json";
import trContactUs from "./tr/contact.json";
import trDaoAndMstChain from "./tr/daoandmstchain.json";
import trEcosystem from "./tr/ecosystem.json";
import trEvmBlockChain from "./tr/evmblockchain.json";
import trFooter from "./tr/footer.json";
import trFractionalNode from "./tr/fractionalnode.json";
import trHeader from "./tr/header.json";
import trKycPolicy from "./tr/kycpolicy.json";
import trMstResearchProgram from "./tr/mstresearch.json";
import trNotFound from "./tr/notfound.json";
import trPrivacyPolicy from "./tr/privacy.json";
import trSolutionsSlug from "./tr/solutions.json";
import trTeamAndPartner from "./tr/teampartner.json";
import trTermsAndCondition from "./tr/terms.json";
import trTransparency from "./tr/transparency.json";
import trVision from "./tr/vision.json";
import ukHomepage from "./uk/homepage.json";
import ukAboutMst from "./uk/about.json";
import ukAmbassador from "./uk/ambassador.json";
import ukAmlPolicy from "./uk/amlpolicy.json";
import ukValidationProcess from "./uk/blockvalidation.json";
import ukBuildOnMst from "./uk/buildonmst.json";
import ukCancellation from "./uk/cancellation.json";
import ukCommunity from "./uk/community.json";
import ukContactUs from "./uk/contact.json";
import ukDaoAndMstChain from "./uk/daoandmstchain.json";
import ukEcosystem from "./uk/ecosystem.json";
import ukEvmBlockChain from "./uk/evmblockchain.json";
import ukFooter from "./uk/footer.json";
import ukFractionalNode from "./uk/fractionalnode.json";
import ukHeader from "./uk/header.json";
import ukKycPolicy from "./uk/kycpolicy.json";
import ukMstResearchProgram from "./uk/mstresearch.json";
import ukNotFound from "./uk/notfound.json";
import ukPrivacyPolicy from "./uk/privacy.json";
import ukSolutionsSlug from "./uk/solutions.json";
import ukTeamAndPartner from "./uk/teampartner.json";
import ukTermsAndCondition from "./uk/terms.json";
import ukTransparency from "./uk/transparency.json";
import ukVision from "./uk/vision.json";
import koHomepage from "./ko/homepage.json";
import koAboutMst from "./ko/about.json";
import koAmbassador from "./ko/ambassador.json";
import koAmlPolicy from "./ko/amlpolicy.json";
import koValidationProcess from "./ko/blockvalidation.json";
import koBuildOnMst from "./ko/buildonmst.json";
import koCancellation from "./ko/cancellation.json";
import koCommunity from "./ko/community.json";
import koContactUs from "./ko/contact.json";
import koDaoAndMstChain from "./ko/daoandmstchain.json";
import koEcosystem from "./ko/ecosystem.json";
import koEvmBlockChain from "./ko/evmblockchain.json";
import koFooter from "./ko/footer.json";
import koFractionalNode from "./ko/fractionalnode.json";
import koHeader from "./ko/header.json";
import koKycPolicy from "./ko/kycpolicy.json";
import koMstResearchProgram from "./ko/mstresearch.json";
import koNotFound from "./ko/notfound.json";
import koPrivacyPolicy from "./ko/privacy.json";
import koSolutionsSlug from "./ko/solutions.json";
import koTeamAndPartner from "./ko/teampartner.json";
import koTermsAndCondition from "./ko/terms.json";
import koTransparency from "./ko/transparency.json";
import koVision from "./ko/vision.json";
import ptBRHomepage from "./ptBR/homepage.json";
import ptBRAboutMst from "./ptBR/about.json";
import ptBRAmbassador from "./ptBR/ambassador.json";
import ptBRAmlPolicy from "./ptBR/amlpolicy.json";
import ptBRValidationProcess from "./ptBR/blockvalidation.json";
import ptBRBuildOnMst from "./ptBR/buildonmst.json";
import ptBRCancellation from "./ptBR/cancellation.json";
import ptBRCommunity from "./ptBR/community.json";
import ptBRContactUs from "./ptBR/contact.json";
import ptBRDaoAndMstChain from "./ptBR/daoandmstchain.json";
import ptBREcosystem from "./ptBR/ecosystem.json";
import ptBREvmBlockChain from "./ptBR/evmblockchain.json";
import ptBRFooter from "./ptBR/footer.json";
import ptBRFractionalNode from "./ptBR/fractionalnode.json";
import ptBRHeader from "./ptBR/header.json";
import ptBRKycPolicy from "./ptBR/kycpolicy.json";
import ptBRMstResearchProgram from "./ptBR/mstresearch.json";
import ptBRNotFound from "./ptBR/notfound.json";
import ptBRPrivacyPolicy from "./ptBR/privacy.json";
import ptBRSolutionsSlug from "./ptBR/solutions.json";
import ptBRTeamAndPartner from "./ptBR/teampartner.json";
import ptBRTermsAndCondition from "./ptBR/terms.json";
import ptBRTransparency from "./ptBR/transparency.json";
import ptBRVision from "./ptBR/vision.json";
import idHomepage from "./id/homepage.json";
import idAboutMst from "./id/about.json";
import idAmbassador from "./id/ambassador.json";
import idAmlPolicy from "./id/amlpolicy.json";
import idValidationProcess from "./id/blockvalidation.json";
import idBuildOnMst from "./id/buildonmst.json";
import idCancellation from "./id/cancellation.json";
import idCommunity from "./id/community.json";
import idContactUs from "./id/contact.json";
import idDaoAndMstChain from "./id/daoandmstchain.json";
import idEcosystem from "./id/ecosystem.json";
import idEvmBlockChain from "./id/evmblockchain.json";
import idFooter from "./id/footer.json";
import idFractionalNode from "./id/fractionalnode.json";
import idHeader from "./id/header.json";
import idKycPolicy from "./id/kycpolicy.json";
import idMstResearchProgram from "./id/mstresearch.json";
import idNotFound from "./id/notfound.json";
import idPrivacyPolicy from "./id/privacy.json";
import idSolutionsSlug from "./id/solutions.json";
import idTeamAndPartner from "./id/teampartner.json";
import idTermsAndCondition from "./id/terms.json";
import idTransparency from "./id/transparency.json";
import idVision from "./id/vision.json";
import haHomepage from "./ha/homepage.json";
import haAboutMst from "./ha/about.json";
import haAmbassador from "./ha/ambassador.json";
import haAmlPolicy from "./ha/amlpolicy.json";
import haValidationProcess from "./ha/blockvalidation.json";
import haBuildOnMst from "./ha/buildonmst.json";
import haCancellation from "./ha/cancellation.json";
import haCommunity from "./ha/community.json";
import haContactUs from "./ha/contact.json";
import haDaoAndMstChain from "./ha/daoandmstchain.json";
import haEcosystem from "./ha/ecosystem.json";
import haEvmBlockChain from "./ha/evmblockchain.json";
import haFooter from "./ha/footer.json";
import haFractionalNode from "./ha/fractionalnode.json";
import haHeader from "./ha/header.json";
import haKycPolicy from "./ha/kycpolicy.json";
import haMstResearchProgram from "./ha/mstresearch.json";
import haNotFound from "./ha/notfound.json";
import haPrivacyPolicy from "./ha/privacy.json";
import haSolutionsSlug from "./ha/solutions.json";
import haTeamAndPartner from "./ha/teampartner.json";
import haTermsAndCondition from "./ha/terms.json";
import haTransparency from "./ha/transparency.json";
import haVision from "./ha/vision.json";
import igHomepage from "./ig/homepage.json";
import igAboutMst from "./ig/about.json";
import igAmbassador from "./ig/ambassador.json";
import igAmlPolicy from "./ig/amlpolicy.json";
import igValidationProcess from "./ig/blockvalidation.json";
import igBuildOnMst from "./ig/buildonmst.json";
import igCancellation from "./ig/cancellation.json";
import igCommunity from "./ig/community.json";
import igContactUs from "./ig/contact.json";
import igDaoAndMstChain from "./ig/daoandmstchain.json";
import igEcosystem from "./ig/ecosystem.json";
import igEvmBlockChain from "./ig/evmblockchain.json";
import igFooter from "./ig/footer.json";
import igFractionalNode from "./ig/fractionalnode.json";
import igHeader from "./ig/header.json";
import igKycPolicy from "./ig/kycpolicy.json";
import igMstResearchProgram from "./ig/mstresearch.json";
import igNotFound from "./ig/notfound.json";
import igPrivacyPolicy from "./ig/privacy.json";
import igSolutionsSlug from "./ig/solutions.json";
import igTeamAndPartner from "./ig/teampartner.json";
import igTermsAndCondition from "./ig/terms.json";
import igTransparency from "./ig/transparency.json";
import igVision from "./ig/vision.json";
import yoHomepage from "./yo/homepage.json";
import yoAboutMst from "./yo/about.json";
import yoAmbassador from "./yo/ambassador.json";
import yoAmlPolicy from "./yo/amlpolicy.json";
import yoValidationProcess from "./yo/blockvalidation.json";
import yoBuildOnMst from "./yo/buildonmst.json";
import yoCancellation from "./yo/cancellation.json";
import yoCommunity from "./yo/community.json";
import yoContactUs from "./yo/contact.json";
import yoDaoAndMstChain from "./yo/daoandmstchain.json";
import yoEcosystem from "./yo/ecosystem.json";
import yoEvmBlockChain from "./yo/evmblockchain.json";
import yoFooter from "./yo/footer.json";
import yoFractionalNode from "./yo/fractionalnode.json";
import yoHeader from "./yo/header.json";
import yoKycPolicy from "./yo/kycpolicy.json";
import yoMstResearchProgram from "./yo/mstresearch.json";
import yoNotFound from "./yo/notfound.json";
import yoPrivacyPolicy from "./yo/privacy.json";
import yoSolutionsSlug from "./yo/solutions.json";
import yoTeamAndPartner from "./yo/teampartner.json";
import yoTermsAndCondition from "./yo/terms.json";
import yoTransparency from "./yo/transparency.json";
import yoVision from "./yo/vision.json";
import bnHomepage from "./bn/homepage.json";
import bnAboutMst from "./bn/about.json";
import bnAmbassador from "./bn/ambassador.json";
import bnAmlPolicy from "./bn/amlpolicy.json";
import bnValidationProcess from "./bn/blockvalidation.json";
import bnBuildOnMst from "./bn/buildonmst.json";
import bnCancellation from "./bn/cancellation.json";
import bnCommunity from "./bn/community.json";
import bnContactUs from "./bn/contact.json";
import bnDaoAndMstChain from "./bn/daoandmstchain.json";
import bnEcosystem from "./bn/ecosystem.json";
import bnEvmBlockChain from "./bn/evmblockchain.json";
import bnFooter from "./bn/footer.json";
import bnFractionalNode from "./bn/fractionalnode.json";
import bnHeader from "./bn/header.json";
import bnKycPolicy from "./bn/kycpolicy.json";
import bnMstResearchProgram from "./bn/mstresearch.json";
import bnNotFound from "./bn/notfound.json";
import bnPrivacyPolicy from "./bn/privacy.json";
import bnSolutionsSlug from "./bn/solutions.json";
import bnTeamAndPartner from "./bn/teampartner.json";
import bnTermsAndCondition from "./bn/terms.json";
import bnTransparency from "./bn/transparency.json";
import bnVision from "./bn/vision.json";
import knHomepage from "./kn/homepage.json";
import knAboutMst from "./kn/about.json";
import knAmbassador from "./kn/ambassador.json";
import knAmlPolicy from "./kn/amlpolicy.json";
import knValidationProcess from "./kn/blockvalidation.json";
import knBuildOnMst from "./kn/buildonmst.json";
import knCancellation from "./kn/cancellation.json";
import knCommunity from "./kn/community.json";
import knContactUs from "./kn/contact.json";
import knDaoAndMstChain from "./kn/daoandmstchain.json";
import knEcosystem from "./kn/ecosystem.json";
import knEvmBlockChain from "./kn/evmblockchain.json";
import knFooter from "./kn/footer.json";
import knFractionalNode from "./kn/fractionalnode.json";
import knHeader from "./kn/header.json";
import knKycPolicy from "./kn/kycpolicy.json";
import knMstResearchProgram from "./kn/mstresearch.json";
import knNotFound from "./kn/notfound.json";
import knPrivacyPolicy from "./kn/privacy.json";
import knSolutionsSlug from "./kn/solutions.json";
import knTeamAndPartner from "./kn/teampartner.json";
import knTermsAndCondition from "./kn/terms.json";
import knTransparency from "./kn/transparency.json";
import knVision from "./kn/vision.json";
import mlHomepage from "./ml/homepage.json";
import mlAboutMst from "./ml/about.json";
import mlAmbassador from "./ml/ambassador.json";
import mlAmlPolicy from "./ml/amlpolicy.json";
import mlValidationProcess from "./ml/blockvalidation.json";
import mlBuildOnMst from "./ml/buildonmst.json";
import mlCancellation from "./ml/cancellation.json";
import mlCommunity from "./ml/community.json";
import mlContactUs from "./ml/contact.json";
import mlDaoAndMstChain from "./ml/daoandmstchain.json";
import mlEcosystem from "./ml/ecosystem.json";
import mlEvmBlockChain from "./ml/evmblockchain.json";
import mlFooter from "./ml/footer.json";
import mlFractionalNode from "./ml/fractionalnode.json";
import mlHeader from "./ml/header.json";
import mlKycPolicy from "./ml/kycpolicy.json";
import mlMstResearchProgram from "./ml/mstresearch.json";
import mlNotFound from "./ml/notfound.json";
import mlPrivacyPolicy from "./ml/privacy.json";
import mlSolutionsSlug from "./ml/solutions.json";
import mlTeamAndPartner from "./ml/teampartner.json";
import mlTermsAndCondition from "./ml/terms.json";
import mlTransparency from "./ml/transparency.json";
import mlVision from "./ml/vision.json";
import taHomepage from "./ta/homepage.json";
import taAboutMst from "./ta/about.json";
import taAmbassador from "./ta/ambassador.json";
import taAmlPolicy from "./ta/amlpolicy.json";
import taValidationProcess from "./ta/blockvalidation.json";
import taBuildOnMst from "./ta/buildonmst.json";
import taCancellation from "./ta/cancellation.json";
import taCommunity from "./ta/community.json";
import taContactUs from "./ta/contact.json";
import taDaoAndMstChain from "./ta/daoandmstchain.json";
import taEcosystem from "./ta/ecosystem.json";
import taEvmBlockChain from "./ta/evmblockchain.json";
import taFooter from "./ta/footer.json";
import taFractionalNode from "./ta/fractionalnode.json";
import taHeader from "./ta/header.json";
import taKycPolicy from "./ta/kycpolicy.json";
import taMstResearchProgram from "./ta/mstresearch.json";
import taNotFound from "./ta/notfound.json";
import taPrivacyPolicy from "./ta/privacy.json";
import taSolutionsSlug from "./ta/solutions.json";
import taTeamAndPartner from "./ta/teampartner.json";
import taTermsAndCondition from "./ta/terms.json";
import taTransparency from "./ta/transparency.json";
import taVision from "./ta/vision.json";
import teHomepage from "./te/homepage.json";
import teAboutMst from "./te/about.json";
import teAmbassador from "./te/ambassador.json";
import teAmlPolicy from "./te/amlpolicy.json";
import teValidationProcess from "./te/blockvalidation.json";
import teBuildOnMst from "./te/buildonmst.json";
import teCancellation from "./te/cancellation.json";
import teCommunity from "./te/community.json";
import teContactUs from "./te/contact.json";
import teDaoAndMstChain from "./te/daoandmstchain.json";
import teEcosystem from "./te/ecosystem.json";
import teEvmBlockChain from "./te/evmblockchain.json";
import teFooter from "./te/footer.json";
import teFractionalNode from "./te/fractionalnode.json";
import teHeader from "./te/header.json";
import teKycPolicy from "./te/kycpolicy.json";
import teMstResearchProgram from "./te/mstresearch.json";
import teNotFound from "./te/notfound.json";
import tePrivacyPolicy from "./te/privacy.json";
import teSolutionsSlug from "./te/solutions.json";
import teTeamAndPartner from "./te/teampartner.json";
import teTermsAndCondition from "./te/terms.json";
import teTransparency from "./te/transparency.json";
import teVision from "./te/vision.json";

import bnPartners from "./bn/partners.json";
import dvPartners from "./dv/partners.json";
import enPartners from "./en/partners.json";
import filPartners from "./fil/partners.json";
import haPartners from "./ha/partners.json";
import hakTWPartners from "./hak-TW/partners.json";
import hiPartners from "./hi/partners.json";
import idPartners from "./id/partners.json";
import igPartners from "./ig/partners.json";
import kmPartners from "./km/partners.json";
import knPartners from "./kn/partners.json";
import koPartners from "./ko/partners.json";
import mlPartners from "./ml/partners.json";
import nanTWPartners from "./nan-TW/partners.json";
import ptBRPartners from "./ptBR/partners.json";
import ruPartners from "./ru/partners.json";
import taPartners from "./ta/partners.json";
import tePartners from "./te/partners.json";
import thPartners from "./th/partners.json";
import trPartners from "./tr/partners.json";
import ukPartners from "./uk/partners.json";
import vtPartners from "./vt/partners.json";
import yoPartners from "./yo/partners.json";
import zhPartners from "./zh/partners.json";
import zhTWPartners from "./zh-TW/partners.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "cookie", "navigator"],
      caches: ["localStorage"],
    },
    resources: {
      en: {
        homepage: enHomepage,
        header: enHeader,
        vision: enVision,
        ecosystem: enEcosystem,
        contact: enContactUs,
        about: enAboutMst,
        blockvalidation: enValidationProcess,
        daoandmstchain: enDaoAndMstChain,
        fractionalnode: enFractionalNode,
        evmblockchain: enEvmBlockChain,
        ambassador: enAmbassador,
        transparency: enTransparency,
        solutions: enSolutionsSlug,
        buildonmst: enBuildOnMst,
        privacy: enPrivacyPolicy,
        terms: enTermsAndCondition,
        cancellation: enCancellation,
        kycpolicy: enKycPolicy,
        amlpolicy: enAmlPolicy,
        teampartner: enTeamAndPartner,
        community: enCommunity,
        mstresearch: enMstResearchProgram,
        footer: enFooter,
        notfound: enNotFound,
        partners: enPartners,
      },
      bn: {
        homepage: bnHomepage,
        header: bnHeader,
        vision: bnVision,
        ecosystem: bnEcosystem,
        contact: bnContactUs,
        about: bnAboutMst,
        blockvalidation: bnValidationProcess,
        daoandmstchain: bnDaoAndMstChain,
        fractionalnode: bnFractionalNode,
        evmblockchain: bnEvmBlockChain,
        ambassador: bnAmbassador,
        transparency: bnTransparency,
        solutions: bnSolutionsSlug,
        buildonmst: bnBuildOnMst,
        privacy: bnPrivacyPolicy,
        terms: bnTermsAndCondition,
        cancellation: bnCancellation,
        kycpolicy: bnKycPolicy,
        amlpolicy: bnAmlPolicy,
        teampartner: bnTeamAndPartner,
        community: bnCommunity,
        mstresearch: bnMstResearchProgram,
        footer: bnFooter,
        notfound: bnNotFound,
        partners: bnPartners,
      },
      hi: {
        homepage: hiHomepage,
        header: hiHeader,
        vision: hiVision,
        ecosystem: hiEcosystem,
        contact: hiContactUs,
        about: hiAboutMst,
        blockvalidation: hiValidationProcess,
        daoandmstchain: hiDaoAndMstChain,
        fractionalnode: hiFractionalNode,
        evmblockchain: hiEvmBlockChain,
        ambassador: hiAmbassador,
        transparency: hiTransparency,
        solutions: hiSolutionsSlug,
        buildonmst: hiBuildOnMst,
        privacy: hiPrivacyPolicy,
        terms: hiTermsAndCondition,
        cancellation: hiCancellation,
        kycpolicy: hiKycPolicy,
        amlpolicy: hiAmlPolicy,
        teampartner: hiTeamAndPartner,
        community: hiCommunity,
        mstresearch: hiMstResearchProgram,
        footer: hiFooter,
        notfound: hiNotFound,
        partners: hiPartners,
      },
      vt: {
        homepage: vtHomepage,
        about: vtAboutMst,
        ambassador: vtAmbassador,
        amlpolicy: vtAmlPolicy,
        blockvalidation: vtValidationProcess,
        buildonmst: vtBuildOnMst,
        cancellation: vtCancellation,
        community: vtCommunity,
        contact: vtContactUs,
        daoandmstchain: vtDaoAndMstChain,
        ecosystem: vtEcosystem,
        evmblockchain: vtEvmBlockChain,
        footer: vtFooter,
        fractionalnode: vtFractionalNode,
        header: vtHeader,
        kycpolicy: vtKycPolicy,
        mstresearch: vtMstResearchProgram,
        notfound: vtNotFound,
        privacy: vtPrivacyPolicy,
        solutions: vtSolutionsSlug,
        teampartner: vtTeamAndPartner,
        terms: vtTermsAndCondition,
        transparency: vtTransparency,
        vision: vtVision,
        partners: vtPartners,
      },
      th: {
        homepage: thHomepage,
        about: thAboutMst,
        ambassador: thAmbassador,
        amlpolicy: thAmlPolicy,
        blockvalidation: thValidationProcess,
        buildonmst: thBuildOnMst,
        cancellation: thCancellation,
        community: thCommunity,
        contact: thContactUs,
        daoandmstchain: thDaoAndMstChain,
        ecosystem: thEcosystem,
        evmblockchain: thEvmBlockChain,
        footer: thFooter,
        fractionalnode: thFractionalNode,
        header: thHeader,
        kycpolicy: thKycPolicy,
        mstresearch: thMstResearchProgram,
        notfound: thNotFound,
        privacy: thPrivacyPolicy,
        solutions: thSolutionsSlug,
        teampartner: thTeamAndPartner,
        terms: thTermsAndCondition,
        transparency: thTransparency,
        vision: thVision,
        partners: thPartners,
      },
      fil: {
        homepage: filHomepage,
        about: filAboutMst,
        ambassador: filAmbassador,
        amlpolicy: filAmlPolicy,
        blockvalidation: filValidationProcess,
        buildonmst: filBuildOnMst,
        cancellation: filCancellation,
        community: filCommunity,
        contact: filContactUs,
        daoandmstchain: filDaoAndMstChain,
        ecosystem: filEcosystem,
        evmblockchain: filEvmBlockChain,
        footer: filFooter,
        fractionalnode: filFractionalNode,
        header: filHeader,
        kycpolicy: filKycPolicy,
        mstresearch: filMstResearchProgram,
        notfound: filNotFound,
        privacy: filPrivacyPolicy,
        solutions: filSolutionsSlug,
        teampartner: filTeamAndPartner,
        terms: filTermsAndCondition,
        transparency: filTransparency,
        vision: filVision,
        partners: filPartners,
      },
      km: {
        homepage: kmHomepage,
        about: kmAboutMst,
        ambassador: kmAmbassador,
        amlpolicy: kmAmlPolicy,
        blockvalidation: kmValidationProcess,
        buildonmst: kmBuildOnMst,
        cancellation: kmCancellation,
        community: kmCommunity,
        contact: kmContactUs,
        daoandmstchain: kmDaoAndMstChain,
        ecosystem: kmEcosystem,
        evmblockchain: kmEvmBlockChain,
        footer: kmFooter,
        fractionalnode: kmFractionalNode,
        header: kmHeader,
        kycpolicy: kmKycPolicy,
        mstresearch: kmMstResearchProgram,
        notfound: kmNotFound,
        privacy: kmPrivacyPolicy,
        solutions: kmSolutionsSlug,
        teampartner: kmTeamAndPartner,
        terms: kmTermsAndCondition,
        transparency: kmTransparency,
        vision: kmVision,
        partners: kmPartners,
      },
      dv: {
        homepage: dvHomepage,
        about: dvAboutMst,
        ambassador: dvAmbassador,
        amlpolicy: dvAmlPolicy,
        blockvalidation: dvValidationProcess,
        buildonmst: dvBuildOnMst,
        cancellation: dvCancellation,
        community: dvCommunity,
        contact: dvContactUs,
        daoandmstchain: dvDaoAndMstChain,
        ecosystem: dvEcosystem,
        evmblockchain: dvEvmBlockChain,
        footer: dvFooter,
        fractionalnode: dvFractionalNode,
        header: dvHeader,
        kycpolicy: dvKycPolicy,
        mstresearch: dvMstResearchProgram,
        notfound: dvNotFound,
        privacy: dvPrivacyPolicy,
        solutions: dvSolutionsSlug,
        teampartner: dvTeamAndPartner,
        terms: dvTermsAndCondition,
        transparency: dvTransparency,
        vision: dvVision,
        partners: dvPartners,
      },
      zh: {
        homepage: zhHomepage,
        about: zhAboutMst,
        ambassador: zhAmbassador,
        amlpolicy: zhAmlPolicy,
        blockvalidation: zhValidationProcess,
        buildonmst: zhBuildOnMst,
        cancellation: zhCancellation,
        community: zhCommunity,
        contact: zhContactUs,
        daoandmstchain: zhDaoAndMstChain,
        ecosystem: zhEcosystem,
        evmblockchain: zhEvmBlockChain,
        footer: zhFooter,
        fractionalnode: zhFractionalNode,
        header: zhHeader,
        kycpolicy: zhKycPolicy,
        mstresearch: zhMstResearchProgram,
        notfound: zhNotFound,
        privacy: zhPrivacyPolicy,
        solutions: zhSolutionsSlug,
        teampartner: zhTeamAndPartner,
        terms: zhTermsAndCondition,
        transparency: zhTransparency,
        vision: zhVision,
        partners: zhPartners,
      },
      ru: {
        homepage: ruHomepage,
        about: ruAboutMst,
        ambassador: ruAmbassador,
        amlpolicy: ruAmlPolicy,
        blockvalidation: ruValidationProcess,
        buildonmst: ruBuildOnMst,
        cancellation: ruCancellation,
        community: ruCommunity,
        contact: ruContactUs,
        daoandmstchain: ruDaoAndMstChain,
        ecosystem: ruEcosystem,
        evmblockchain: ruEvmBlockChain,
        footer: ruFooter,
        fractionalnode: ruFractionalNode,
        header: ruHeader,
        kycpolicy: ruKycPolicy,
        mstresearch: ruMstResearchProgram,
        notfound: ruNotFound,
        privacy: ruPrivacyPolicy,
        solutions: ruSolutionsSlug,
        teampartner: ruTeamAndPartner,
        terms: ruTermsAndCondition,
        transparency: ruTransparency,
        vision: ruVision,
        partners: ruPartners,
      },
      tr: {
        homepage: trHomepage,
        about: trAboutMst,
        ambassador: trAmbassador,
        amlpolicy: trAmlPolicy,
        blockvalidation: trValidationProcess,
        buildonmst: trBuildOnMst,
        cancellation: trCancellation,
        community: trCommunity,
        contact: trContactUs,
        daoandmstchain: trDaoAndMstChain,
        ecosystem: trEcosystem,
        evmblockchain: trEvmBlockChain,
        footer: trFooter,
        fractionalnode: trFractionalNode,
        header: trHeader,
        kycpolicy: trKycPolicy,
        mstresearch: trMstResearchProgram,
        notfound: trNotFound,
        privacy: trPrivacyPolicy,
        solutions: trSolutionsSlug,
        teampartner: trTeamAndPartner,
        terms: trTermsAndCondition,
        transparency: trTransparency,
        vision: trVision,
        partners: trPartners,
      },
      uk: {
        homepage: ukHomepage,
        about: ukAboutMst,
        ambassador: ukAmbassador,
        amlpolicy: ukAmlPolicy,
        blockvalidation: ukValidationProcess,
        buildonmst: ukBuildOnMst,
        cancellation: ukCancellation,
        community: ukCommunity,
        contact: ukContactUs,
        daoandmstchain: ukDaoAndMstChain,
        ecosystem: ukEcosystem,
        evmblockchain: ukEvmBlockChain,
        footer: ukFooter,
        fractionalnode: ukFractionalNode,
        header: ukHeader,
        kycpolicy: ukKycPolicy,
        mstresearch: ukMstResearchProgram,
        notfound: ukNotFound,
        privacy: ukPrivacyPolicy,
        solutions: ukSolutionsSlug,
        teampartner: ukTeamAndPartner,
        terms: ukTermsAndCondition,
        transparency: ukTransparency,
        vision: ukVision,
        partners: ukPartners,
      },
      ko: {
        homepage: koHomepage,
        about: koAboutMst,
        ambassador: koAmbassador,
        amlpolicy: koAmlPolicy,
        blockvalidation: koValidationProcess,
        buildonmst: koBuildOnMst,
        cancellation: koCancellation,
        community: koCommunity,
        contact: koContactUs,
        daoandmstchain: koDaoAndMstChain,
        ecosystem: koEcosystem,
        evmblockchain: koEvmBlockChain,
        footer: koFooter,
        fractionalnode: koFractionalNode,
        header: koHeader,
        kycpolicy: koKycPolicy,
        mstresearch: koMstResearchProgram,
        notfound: koNotFound,
        privacy: koPrivacyPolicy,
        solutions: koSolutionsSlug,
        teampartner: koTeamAndPartner,
        terms: koTermsAndCondition,
        transparency: koTransparency,
        vision: koVision,
        partners: koPartners,
      },
      ptBR: {
        homepage: ptBRHomepage,
        about: ptBRAboutMst,
        ambassador: ptBRAmbassador,
        amlpolicy: ptBRAmlPolicy,
        blockvalidation: ptBRValidationProcess,
        buildonmst: ptBRBuildOnMst,
        cancellation: ptBRCancellation,
        community: ptBRCommunity,
        contact: ptBRContactUs,
        daoandmstchain: ptBRDaoAndMstChain,
        ecosystem: ptBREcosystem,
        evmblockchain: ptBREvmBlockChain,
        footer: ptBRFooter,
        fractionalnode: ptBRFractionalNode,
        header: ptBRHeader,
        kycpolicy: ptBRKycPolicy,
        mstresearch: ptBRMstResearchProgram,
        notfound: ptBRNotFound,
        privacy: ptBRPrivacyPolicy,
        solutions: ptBRSolutionsSlug,
        teampartner: ptBRTeamAndPartner,
        terms: ptBRTermsAndCondition,
        transparency: ptBRTransparency,
        vision: ptBRVision,
        partners: ptBRPartners,
      },
      id: {
        homepage: idHomepage,
        about: idAboutMst,
        ambassador: idAmbassador,
        amlpolicy: idAmlPolicy,
        blockvalidation: idValidationProcess,
        buildonmst: idBuildOnMst,
        cancellation: idCancellation,
        community: idCommunity,
        contact: idContactUs,
        daoandmstchain: idDaoAndMstChain,
        ecosystem: idEcosystem,
        evmblockchain: idEvmBlockChain,
        footer: idFooter,
        fractionalnode: idFractionalNode,
        header: idHeader,
        kycpolicy: idKycPolicy,
        mstresearch: idMstResearchProgram,
        notfound: idNotFound,
        privacy: idPrivacyPolicy,
        solutions: idSolutionsSlug,
        teampartner: idTeamAndPartner,
        terms: idTermsAndCondition,
        transparency: idTransparency,
        vision: idVision,
        partners: idPartners,
      },
      ha: {
        homepage: haHomepage,
        about: haAboutMst,
        ambassador: haAmbassador,
        amlpolicy: haAmlPolicy,
        blockvalidation: haValidationProcess,
        buildonmst: haBuildOnMst,
        cancellation: haCancellation,
        community: haCommunity,
        contact: haContactUs,
        daoandmstchain: haDaoAndMstChain,
        ecosystem: haEcosystem,
        evmblockchain: haEvmBlockChain,
        footer: haFooter,
        fractionalnode: haFractionalNode,
        header: haHeader,
        kycpolicy: haKycPolicy,
        mstresearch: haMstResearchProgram,
        notfound: haNotFound,
        privacy: haPrivacyPolicy,
        solutions: haSolutionsSlug,
        teampartner: haTeamAndPartner,
        terms: haTermsAndCondition,
        transparency: haTransparency,
        vision: haVision,
        partners: haPartners,
      },
      ig: {
        homepage: igHomepage,
        about: igAboutMst,
        ambassador: igAmbassador,
        amlpolicy: igAmlPolicy,
        blockvalidation: igValidationProcess,
        buildonmst: igBuildOnMst,
        cancellation: igCancellation,
        community: igCommunity,
        contact: igContactUs,
        daoandmstchain: igDaoAndMstChain,
        ecosystem: igEcosystem,
        evmblockchain: igEvmBlockChain,
        footer: igFooter,
        fractionalnode: igFractionalNode,
        header: igHeader,
        kycpolicy: igKycPolicy,
        mstresearch: igMstResearchProgram,
        notfound: igNotFound,
        privacy: igPrivacyPolicy,
        solutions: igSolutionsSlug,
        teampartner: igTeamAndPartner,
        terms: igTermsAndCondition,
        transparency: igTransparency,
        vision: igVision,
        partners: igPartners,
      },
      yo: {
        homepage: yoHomepage,
        about: yoAboutMst,
        ambassador: yoAmbassador,
        amlpolicy: yoAmlPolicy,
        blockvalidation: yoValidationProcess,
        buildonmst: yoBuildOnMst,
        cancellation: yoCancellation,
        community: yoCommunity,
        contact: yoContactUs,
        daoandmstchain: yoDaoAndMstChain,
        ecosystem: yoEcosystem,
        evmblockchain: yoEvmBlockChain,
        footer: yoFooter,
        fractionalnode: yoFractionalNode,
        header: yoHeader,
        kycpolicy: yoKycPolicy,
        mstresearch: yoMstResearchProgram,
        notfound: yoNotFound,
        privacy: yoPrivacyPolicy,
        solutions: yoSolutionsSlug,
        teampartner: yoTeamAndPartner,
        terms: yoTermsAndCondition,
        transparency: yoTransparency,
        vision: yoVision,
        partners: yoPartners,
      },
      kn: {
        homepage: knHomepage,
        about: knAboutMst,
        ambassador: knAmbassador,
        amlpolicy: knAmlPolicy,
        blockvalidation: knValidationProcess,
        buildonmst: knBuildOnMst,
        cancellation: knCancellation,
        community: knCommunity,
        contact: knContactUs,
        daoandmstchain: knDaoAndMstChain,
        ecosystem: knEcosystem,
        evmblockchain: knEvmBlockChain,
        footer: knFooter,
        fractionalnode: knFractionalNode,
        header: knHeader,
        kycpolicy: knKycPolicy,
        mstresearch: knMstResearchProgram,
        notfound: knNotFound,
        privacy: knPrivacyPolicy,
        solutions: knSolutionsSlug,
        teampartner: knTeamAndPartner,
        terms: knTermsAndCondition,
        transparency: knTransparency,
        vision: knVision,
        partners: knPartners,
      },
      ml: {
        homepage: mlHomepage,
        about: mlAboutMst,
        ambassador: mlAmbassador,
        amlpolicy: mlAmlPolicy,
        blockvalidation: mlValidationProcess,
        buildonmst: mlBuildOnMst,
        cancellation: mlCancellation,
        community: mlCommunity,
        contact: mlContactUs,
        daoandmstchain: mlDaoAndMstChain,
        ecosystem: mlEcosystem,
        evmblockchain: mlEvmBlockChain,
        footer: mlFooter,
        fractionalnode: mlFractionalNode,
        header: mlHeader,
        kycpolicy: mlKycPolicy,
        mstresearch: mlMstResearchProgram,
        notfound: mlNotFound,
        privacy: mlPrivacyPolicy,
        solutions: mlSolutionsSlug,
        teampartner: mlTeamAndPartner,
        terms: mlTermsAndCondition,
        transparency: mlTransparency,
        vision: mlVision,
        partners: mlPartners,
      },
      ta: {
        homepage: taHomepage,
        about: taAboutMst,
        ambassador: taAmbassador,
        amlpolicy: taAmlPolicy,
        blockvalidation: taValidationProcess,
        buildonmst: taBuildOnMst,
        cancellation: taCancellation,
        community: taCommunity,
        contact: taContactUs,
        daoandmstchain: taDaoAndMstChain,
        ecosystem: taEcosystem,
        evmblockchain: taEvmBlockChain,
        footer: taFooter,
        fractionalnode: taFractionalNode,
        header: taHeader,
        kycpolicy: taKycPolicy,
        mstresearch: taMstResearchProgram,
        notfound: taNotFound,
        privacy: taPrivacyPolicy,
        solutions: taSolutionsSlug,
        teampartner: taTeamAndPartner,
        terms: taTermsAndCondition,
        transparency: taTransparency,
        vision: taVision,
        partners: taPartners,
      },
      te: {
        homepage: teHomepage,
        about: teAboutMst,
        ambassador: teAmbassador,
        amlpolicy: teAmlPolicy,
        blockvalidation: teValidationProcess,
        buildonmst: teBuildOnMst,
        cancellation: teCancellation,
        community: teCommunity,
        contact: teContactUs,
        daoandmstchain: teDaoAndMstChain,
        ecosystem: teEcosystem,
        evmblockchain: teEvmBlockChain,
        footer: teFooter,
        fractionalnode: teFractionalNode,
        header: teHeader,
        kycpolicy: teKycPolicy,
        mstresearch: teMstResearchProgram,
        notfound: teNotFound,
        privacy: tePrivacyPolicy,
        solutions: teSolutionsSlug,
        teampartner: teTeamAndPartner,
        terms: teTermsAndCondition,
        transparency: teTransparency,
        vision: teVision,
        partners: tePartners,
      },
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
